import { render } from "./page-navbar.vue?vue&type=template&id=70409dd6&scoped=true"
import script from "./page-navbar.vue?vue&type=script&lang=js"
export * from "./page-navbar.vue?vue&type=script&lang=js"

import "./page-navbar.vue?vue&type=style&index=0&id=70409dd6&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70409dd6"]])

export default __exports__